/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { Box, Button, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import aiLogo from "../../../assets/aiLogo.png";
import Config from "../../../config/index";
import { getSubModulesByRoleId } from "../../../store";
const cookies = new Cookies();
const WelcomePage = ({
  onStartChat,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data.userId;
  let roleName = loginDetails.data.roleName;
  let roleId = loginDetails.data.roleId;
  let email = loginDetails.data.email;

  let baseUrl = Config.baseUrl;
  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let aiChatBotModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "c38f4dce-6ce0-4812-8a82-c55a5e28a616",
  );
  let chatAccess = aiChatBotModule
    ? aiChatBotModule.actionId.includes("2cc4aa6a-81f4-4137-9f63-445c37b8a7b8")
    : null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "100%",
        width: "100%",
        p: 0,
        fontFamily: "Arial, serif",
        "& .MuiTypography-root": { fontFamily: "Arial, serif" },
        "& .MuiInputBase-input": { fontFamily: "Arial, serif" },
      }}
    >
      {/* Logo */}
      <Box
        sx={{
          position: "relative",
          mb: 2,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={aiLogo}
          alt="MOBY"
          sx={{
            width: "135px",
            height: "auto",
            objectFit: "contain",
            zIndex: 2,
            position: "relative",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: "-6px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "110px",
            height: "22px",
            background:
              "radial-gradient(ellipse at center, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0) 60%)",
            borderRadius: "50%",
            zIndex: 1,
            filter: "blur(2px)",
          }}
        />
      </Box>

      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          color: "text.primary",
          mb: 0.75,
          fontSize: "1.25rem",
        }}
      >
        Hi! I'm MOBY 👋
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          maxWidth: "320px",
          lineHeight: 1.5,
          mb: 2.5,
          fontSize: "0.8rem",
        }}
      >
        Your friendly Mobillor assistant. I’m here to help you with tracking of
        item storage, production, and reporting.
      </Typography>

      {/* Label */}
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          opacity: 0.7,
          mb: 1.5,
          fontSize: "0.75rem",
          fontWeight: 500,
        }}
      >
        Try asking me:
      </Typography>

      {/* Buttons */}
      {chatAccess && (
        <Stack spacing={1.25} sx={{ width: "100%", maxWidth: "280px" }}>
          <StyledButton
            onClick={() => onStartChat("What can you help me with?")}
          >
            What can you help me with?
          </StyledButton>

          <StyledButton
            onClick={() => onStartChat("Tell me about your features")}
          >
            Tell me about your features
          </StyledButton>

          <StyledButton onClick={() => onStartChat()}>Let's Chat</StyledButton>
        </Stack>
      )}
    </Box>
  );
};

const StyledButton = ({ children, onClick }) => (
  <Button
    variant="outlined"
    onClick={onClick}
    size="small"
    sx={{
      textTransform: "none",
      borderRadius: "999px",
      borderColor: "divider",
      color: "text.primary",

      padding: "6px 14px",
      fontSize: "0.78rem",
      fontWeight: 500,
      backgroundColor: "background.paper",

      minHeight: 30,
      boxShadow: "0px 1px 3px rgba(0,0,0,0.02)",

      "&:hover": {
        backgroundColor: "action.hover",
        borderColor: "text.primary",
        boxShadow: "0px 2px 5px rgba(0,0,0,0.05)",
      },
    }}
  >
    {children}
  </Button>
);

const mapStateToProps = (state) => ({
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WelcomePage);
